export default class RemoveContentLinksModifier
{
    modifyPreRender(htmlString){
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');

        const links = doc.querySelectorAll('a');
        links.forEach(link => {
            const span = doc.createElement('span');
            span.innerHTML = link.innerHTML; // preserve inner HTML
            link.parentNode.replaceChild(span, link);
        });

        return doc.body.innerHTML;
    }
    modifyPostRender(contentRootElement){}
}